import React from 'react';

export default function Footer() {
  return(
    <a className="footer" href="http://www.tmdb.org" target="_blank" rel='noreferrer noopener'>Movie info from TMDB. Thanks!</a>
  )

}